import FormSearchBtn from "components/button/formSearch";
import SubHeader from "components/layout/header/subHeader";
import Select from "components/select";
import LodChlSelect from "components/select/room/lodChlSelect";
import LodGrdSelect from "components/select/room/lodGrdSelect";
import LodGrpSelect from "components/select/room/lodGrpNoSelect";
import LodNoSelect from "components/select/room/lodNoSelect";
import LodChlList from "components/tableList/lod/chl";
import { lodChlSearchProps } from "interface/lod";
import { channelOptions, lodGrpStatus } from "util/option";

type IProps = {
  searchInfo: lodChlSearchProps;
  memType: "admin" | "manager";
  handleChange(name: string, value: string): void;
  handleSelect(target: EventTarget & HTMLLIElement): void;
  handleReset(): void;
  handleSearch(): void;
};

const LodChannelListView = ({
  searchInfo,
  memType,
  handleChange,
  handleSelect,
  handleReset,
  handleSearch,
}: IProps) => {
  return (
    <>
      <div className="search-form">
        <SubHeader title="숙소채널" add />
        <div className="table-form">
          <table>
            <tbody>
              {memType === "admin" && (
                <tr>
                  <th>숙소그룹번호</th>
                  <td>
                    <LodGrpSelect
                      option={searchInfo?.lodGrpNo}
                      onSelect={(target) => handleSelect(target)}
                    />
                  </td>
                  <th>숙소그룹명</th>
                  <td>
                    <LodGrpSelect
                      option={searchInfo?.lodGrpNo}
                      onSelect={(target) => handleSelect(target)}
                    />
                  </td>
                </tr>
              )}
              <tr>
                <th>숙소번호</th>
                <td>
                  <LodNoSelect
                    option={searchInfo?.lodGrpNo}
                    params={searchInfo?.lodNo}
                    onSelect={(target) => handleSelect(target)}
                  />
                </td>
                <th>숙소명</th>
                <td>
                  <LodNoSelect
                    option={searchInfo.lodNo}
                    params={searchInfo.lodGrpNo}
                    onSelect={(target) => handleSelect(target)}
                  />
                </td>
              </tr>
              <tr>
                <th>숙소등급</th>
                <td>
                  <LodGrdSelect
                    option={searchInfo?.lodGrdCd}
                    onSelect={(target) => handleSelect(target)}
                  />
                </td>
                <th>숙소채널</th>
                <td>
                  <LodChlSelect
                    option={searchInfo?.lodChlCd}
                    onSelect={(target) => handleSelect(target)}
                  />
                </td>
              </tr>

              <tr>
                <th>조회시작일자</th>
                <td>
                  <input
                    type="date"
                    id="date"
                    max="2100-12-30"
                    value={searchInfo?.SDt}
                    onChange={(e) => {
                      handleChange("SDt", e.currentTarget.value);
                    }}
                  />
                </td>
                <th>조회종료일자</th>
                <td>
                  <input
                    type="date"
                    id="date"
                    max="2100-12-31"
                    value={searchInfo?.EDt}
                    onChange={(e) => {
                      handleChange("EDt", e.currentTarget.value);
                    }}
                  />
                </td>
              </tr>
              <tr>
                <th>상태</th>
                <td>
                  <Select
                    id=""
                    name=""
                    options={lodGrpStatus}
                    onSelect={(target) => handleSelect(target)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <FormSearchBtn
            disabled={false}
            handleSearch={handleSearch}
            handleReset={handleReset}
          />
        </div>
      </div>
      <LodChlList
        isLoading={false}
        memType={memType}
        searchInfo={searchInfo}
        list={[]}
      />
    </>
  );
};

export default LodChannelListView;
